import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { ApiSingleResponse } from '../interfaces/responses/api-response';
import { MyRegistration, SubmitProofDto } from '../interfaces/registration';

/**
 * Dossier d'inscription de l'élève connecté.
 *
 * <p>Le back résout la demande par le `sub` du jeton, pas par le claim
 * `id_student` : un élève dont l'inscription n'est pas encore validée doit
 * pouvoir consulter son dossier et y déposer son justificatif.</p>
 */
@Injectable({ providedIn: 'root' })
export class RegistrationService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.BASE_URL}/students/me/registration`;

  /** 404 si le compte n'est pas issu d'une inscription en ligne. */
  getMine(): Observable<ApiSingleResponse<MyRegistration>> {
    return this.http.get<ApiSingleResponse<MyRegistration>>(this.baseUrl);
  }

  /** Dépose ou remplace le justificatif de virement. */
  submitProof(dto: SubmitProofDto): Observable<ApiSingleResponse<MyRegistration>> {
    return this.http.put<ApiSingleResponse<MyRegistration>>(
      `${this.baseUrl}/proof`,
      dto,
    );
  }
}
